import { Toast } from "vant";
import wxJsSdk from "@/common/location";
import common from '@/common/old/public/common'
import { router } from "@/router";
/**
 * 对充电站列表数据操作
 * @param {*} stationList
 * @returns
 */
export const forStationList = (stationList) => {
  let arr = [];
  stationList.map((item) => {
    let campaignPriceList = item.campaignPriceList;
    if (campaignPriceList) {
      // 有活动调价
      item.campaignPrice = campaignPriceList[0];
    }
    let priceObj = {};
    if (item.currentPriceList && item.currentPriceList.length > 1) {
      item.currentPriceList.map((item) => {
        if (item.vipType != 1) {
          priceObj = item;
        }
      });
    } else if (item.currentPriceList && item.currentPriceList[0]) {
      priceObj = item.currentPriceList[0] || {};
    }
    item.priceObj = priceObj;
    arr.push(item);
  });
  return arr;
};

/**
 * 扫码解析参数
 * @param {*} url
 * @returns
 */
export const qrcodeData = (url) => {
  let str = "hlht://";
  if (url.indexOf(str) != -1) {
    let dataStr = url.substring(str.length, url.length);
    let arr = dataStr.split(".");
    let gunPkId = arr[0];
    let operatorId = "";
    let customInfo = "";
    if (arr[1]) {
      let arr2 = arr[1].split("/");
      operatorId = arr2[0];
      customInfo = arr2[1] || "";
      return {
        gunPkId: gunPkId,
        operatorId: operatorId,
        customInfo: customInfo,
      };
    } else {
      Toast("二维码错误", "none");
      return null;
    }
  } else if (url.indexOf("http://") != -1 || url.indexOf("https://") != -1) {
    let gunPkId = queryUrl("gid", url);
    let operatorId = queryUrl("orgCode", url);
    if (gunPkId && operatorId) {
      return {
        gunPkId: gunPkId,
        operatorId: operatorId,
        customInfo: "",
      };
    } else {
      Toast("请扫描正确的二维码");
      return null;
    }
  } else {
    Toast("二维码错误", "none");
    return null;
  }
};
/**
 * 解析URL上的参数
 * @param {*} name
 * @param {*} url
 * @returns
 */
const queryUrl = (name, url) => {
  return (
    decodeURIComponent(
      (new RegExp("[?|&]" + name + "=" + "([^&;]+?)(&|#|;|$)").exec(url) || [
        "",
        "",
      ])[1].replace(/\+/g, "%20")
    ) || false
  );
};
/**
 * 根据订单状态跳转页面
 * @param {*} orderInfo
 * @param {*} orders
 */
export const orderStatusGoPage = (orderInfo, orders) => {
  if (orderInfo.orderStatus === 1) {
    //正在充电
    router.push({
      name: "charge/charging",
      query: {
        orderNo: orderInfo.orderNo,
      },
    });
  } else if (orderInfo.orderStatus === 2) {
    //充电完成，跳转到充电结束界面等待拔枪
    router.push({
      name: "charge/finish",
      query: {
        orderNo: orderInfo.orderNo,
      },
    });
  } else if (orderInfo.orderStatus === 5) {
    //充电完成，待支付，跳转到支付界面
    router.push({
      name: "order-not-pay",
      query: {
        orderNo: orderInfo.orderNo,
      },
    });
  } else if (orderInfo.orderStatus === 0) {
    //启动中
    router.push({
      name: "charge/launching",
      query: {
        orderNo: orderInfo.orderNo,
      },
    });
  } else if (orderInfo.orderStatus === 6) {
    orders = orders ? orders : orderInfo.orderNo;
    router.push({
      name: "my/order",
      query: {
        orderState: 2,
        userType: "",
        orderNo: orders,
      },
    });
  }
};
/**
 * 扫码
 */
export const scanCodeRecharge = () => {
  wxJsSdk.scanQRCode({
    success: (res) => {
      let data = getScanCodeData(res);
      if (data) {
        router.push({
          name: "charge/ready",
          query: data,
        });
      } else {
        Toast("二维码不正确，请重新扫描");
      }
    },
    fail: () => {
      Toast("扫码失败");
    },
  });
};
/**
 * 解析参数
 * @param {*} url 
 * @returns 
 */
export const getScanCodeData = (url) => {
  let str = "hlht://";
  if (url.indexOf(str) != -1) {
    let dataStr = url.substring(str.length, url.length);
    let arr = dataStr.split(".");
    let gunPkId = arr[0];
    let operatorId = "";
    let customInfo = "";
    if (arr[1]) {
      let arr2 = arr[1].split("/");
      operatorId = arr2[0];
      customInfo = arr2[1] || "";
      return {
        gunPkId: gunPkId,
        operatorId: operatorId,
        customInfo: customInfo,
      };
    } else {
      Toast("请扫描正确的二维码");
      return null;
    }
  } else if (url.indexOf("http://") != -1 || url.indexOf("https://") != -1) {
    let gunPkId = common.query("gid", url);
    let operatorId = common.query("orgCode", url);
    if (gunPkId && operatorId) {
      return {
        gunPkId: gunPkId,
        operatorId: operatorId,
        customInfo: "",
      };
    } else {
      Toast("请扫描正确的二维码");
      return null;
    }
  } else {
    Toast("请扫描正确的二维码");
    return null;
  }
};

